import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "PlusBlack",
  "use": "PlusBlack-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol viewBox=\"0 0 14 14\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"PlusBlack\">\n<path d=\"M14 8H8V14H6V8H0V6H6V0H8V6H14V8Z\" fill=\"#1B1B1B\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol